<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Payments' }}</h2>
      <p>Every member payment, its status and the gateway result.</p>
    </div>
    <p-button label="Refresh" icon="pi pi-refresh" [outlined]="true" (onClick)="load()" />
  </div>

  <div class="card">
    <div class="toolbar">
      <p-iconfield iconPosition="left" class="search-field">
        <p-inputicon styleClass="pi pi-search" />
        <input type="text" pInputText placeholder="Search member, uid, status or gateway..."
          [ngModel]="search()" (ngModelChange)="search.set($event)">
      </p-iconfield>
      <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
    </div>

    <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th>Member</th>
          <th>Payment Uid</th>
          <th class="ta-r">Amount</th>
          <th>Mode</th>
          <th>Payer</th>
          <th>Status</th>
          <th>Paid At</th>
          <th>Gateway</th>
          <th class="ta-r">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr class="row-click" (click)="openDetail(r)" pTooltip="Open payment details" tooltipPosition="top" [showDelay]="500">
          <td class="name">
            {{ r.memberName || ('Member #' + r.memberId) }}
            @if (r.memberUniqueId) { <span class="mono sub">{{ r.memberUniqueId }}</span> }
          </td>
          <td class="mono">{{ r.paymentUniqueId }}</td>
          <td class="ta-r amount">{{ r.amount | number: '1.0-0' }} <span class="cur">{{ r.currency || 'INR' }}</span></td>
          <td>{{ r.paymentMode || '—' }}</td>
          <td><span class="mono">{{ payerLabel(r) }}</span></td>
          <td><p-tag [value]="r.paymentStatus || '—'" [severity]="statusSeverity(r.paymentStatus)" /></td>
          <td>{{ r.paidAt ? (r.paidAt | indDate) : '—' }}</td>
          <td>{{ r.gatewayName || '—' }}</td>
          <td class="ta-r actions" (click)="$event.stopPropagation()">
            <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Quick view" (onClick)="openView(r)" />
            @if (hasReceipt(r)) {
              <p-button icon="pi pi-receipt" [rounded]="true" [text]="true" severity="secondary"
                pTooltip="View receipt" (onClick)="viewReceipt(r)" />
              <p-button icon="pi pi-send" [rounded]="true" [text]="true" severity="secondary"
                pTooltip="Send / Resend documents (COI + receipt)" (onClick)="sendCoi(r)" />
              <p-button icon="pi pi-ellipsis-v" [rounded]="true" [text]="true" severity="secondary"
                pTooltip="More actions" (onClick)="openRowMenu(rowMenu, $event, r)" />
            } @else {
              <p-button icon="pi pi-receipt" [rounded]="true" [text]="true" severity="secondary"
                [disabled]="true" pTooltip="Receipt available after success" />
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9">
            <div class="state"><i class="pi pi-inbox"></i>
              <p>No payments recorded yet.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- shared row overflow menu (print / download / certificate / send) -->
    <p-menu #rowMenu [popup]="true" [model]="rowMenuItems" appendTo="body" />
  </div>
</div>

<!-- ===================== VIEW DIALOG ===================== -->
<p-dialog [visible]="showView()" (visibleChange)="showView.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [dismissableMask]="true" header="Payment Details" styleClass="menu-dialog"
  [style]="{ width: '600px' }" [breakpoints]="{ '600px': '94vw' }">
  @if (viewing(); as v) {
    <div class="view-body">
      <div class="kv-grid">
        <div><span>Member</span><strong>{{ v.memberName || ('Member #' + v.memberId) }}</strong></div>
        <div><span>Payment Uid</span><strong class="mono">{{ v.paymentUniqueId }}</strong></div>
        <div><span>Amount</span><strong>{{ v.amount | number: '1.0-0' }} {{ v.currency || 'INR' }}</strong></div>
        <div><span>Mode</span><strong>{{ v.paymentMode || '—' }}</strong></div>
        <div><span>Payer</span><strong class="mono">{{ payerLabel(v) }}</strong></div>
        <div><span>Status</span><strong><p-tag [value]="v.paymentStatus" [severity]="statusSeverity(v.paymentStatus)" /></strong></div>
        <div><span>Gateway</span><strong>{{ v.gatewayName || '—' }}</strong></div>
        <div><span>Gateway Order Id</span><strong class="mono">{{ v.gatewayOrderId || '—' }}</strong></div>
        <div><span>Gateway Payment Id</span><strong class="mono">{{ v.gatewayPaymentId || '—' }}</strong></div>
        <div><span>Paid At</span><strong>{{ v.paidAt ? (v.paidAt | indDate) : '—' }}</strong></div>
        @if (v.failureReason) { <div class="span-all"><span>Failure Reason</span><strong class="danger">{{ v.failureReason }}</strong></div> }
      </div>

      <div class="json-block">
        <label>Gateway Response</label>
        <pre>{{ prettyJson(v.gatewayResponseJson) || 'No gateway response stored.' }}</pre>
      </div>

      <div class="modal-actions">
        <p-button label="Close" [outlined]="true" (onClick)="closeView()" />
      </div>
    </div>
  }
</p-dialog>

<!-- ===================== RECEIPT DIALOG (shared by every SUCCESS row) ===================== -->
<p-dialog [visible]="showReceipt()" (visibleChange)="showReceipt.set($event)" [modal]="true"
  [draggable]="true" [resizable]="false" [dismissableMask]="true" header="Payment Receipt"
  styleClass="menu-dialog" [style]="{ width: '720px' }" [breakpoints]="{ '720px': '94vw' }">
  @if (showReceipt()) {
    <app-receipt-view [paymentId]="receiptPaymentId()" />
  }
</p-dialog>

<!-- ===================== CERTIFICATE DIALOG (shared by every SUCCESS row) ===================== -->
<p-dialog [visible]="showCoi()" (visibleChange)="showCoi.set($event)" [modal]="true"
  [draggable]="true" [resizable]="false" [dismissableMask]="true" header="Certificate of Insurance"
  styleClass="menu-dialog" [style]="{ width: '900px' }" [breakpoints]="{ '960px': '96vw' }">
  @if (showCoi()) {
    <app-coi-view [memberId]="coiMemberId()" />
  }
</p-dialog>

<!-- ===================== SEND CERTIFICATE (queued WhatsApp / SMS / Email delivery) ===================== -->
<app-send-coi-dialog [(visible)]="showSendCoi" [memberId]="sendCoiMemberId()" />
